var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"search-box"}},[_c('input',{staticClass:"form-control",attrs:{"id":"pac-input","type":"text","placeholder":_vm.translation('type_delivery_location')},on:{"focus":_vm.activateBox,"blur":_vm.deactivateBox}})])}
var staticRenderFns = []

export { render, staticRenderFns }